module.exports = __webpack_public_path__ + "img/Mezcal400ConejosJovenEspadín.6527c67b.jpg";